export const FormTypes = {
  EMAIL: 'EMAIL',
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP',
  RESET: 'RESET',
  FACEBOOK: 'FACEBOOK',
  MAGIC_LINK_PASSWORD: 'MAGIC_LINK_PASSWORD',
  MAGIC_LINK_PASSWORDLESS: 'MAGIC_LINK_PASSWORDLESS',
}
